// @flow

export function sortByOrder<I, T: { id: I }>(columns: T[], order: I[]): T[] {
  return order
    .reduce((acc, id) => {
      const col = columns.find((column) => column.id === id);
      return col ? [...acc, col] : acc;
    }, [])
    .concat(columns.filter((column) => !order.includes(column.id)));
}

export default sortByOrder;



// WEBPACK FOOTER //
// ./src/common/utils/sortByOrder.js